import { AuthService } from "../auth.service";
import { Component, OnInit, ViewContainerRef } from '@angular/core';
// TODO import { FormGroup, Validators } from '@angular/forms';
import { Router } from "@angular/router";

import { UserService } from "../../user/user.service";
import { LaravelApiService } from '../../laravel.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  providers: [AuthService]
})
export class LoginComponent implements OnInit {

  public loginMessage: string = "Control Bright";
  public failedMessage: string = "Sign In";
  public loggingIn = false;
  public user: any = { password:'', email:'' };

  private retryCount: number = 0;

  constructor(
    private router: Router,
    private laravel: LaravelApiService,
    private auth: AuthService,
    private userService : UserService
  ) { }

  ngOnInit() { }

  login(event?) {
    if (event) event.preventDefault();
    this.loggingIn = true;
    this.auth.login(this.user).subscribe(
      val => this.loginSuccess(),
      error => this.handleError(error)
    );
  }

  loginSuccess() {
    this.userService.getLoginInfo().subscribe((user) => {
      this.loggingIn = false;
      this.router.navigate(['']);
    });
  }

  handleError(response) {
    this.loggingIn = false;

    let errTitle = "Login Failed";
    let errMsg;
    if(response.status == '401'){
      errMsg = "Please check your login credentials and try again";
    } else if (response.status == '403'){
      errMsg = "You have been locked out due to too many login attempts. Please try again later.";
    } else if (response.error && response.error.indexOf("TokenMismatchException") > -1) {
      if (this.retryCount < 1) {
        this.retryCount++;
        this.laravel.getClientConfig(true) // forcing request, in order to get new XSRF token cookie
          .subscribe((data) => {
            if (data) {
              this.login();
            } // else... FIXME: a response comes back `null` first, then with real data.
          });
        return; // don't show the notification below
      } else {
        // FIXME: this state can be entered while `login` still has a chance to succeed -- unsure how 2020-09-03T19:02:14Z
        errMsg = 'The security token is mismatched between your device and the ControlBright service. Please be patient while the app reloads.';
      }
    } else if (response.message) {
      errMsg = `Unexpected error: ${response.message}`; // Note: This might contain front-end errors. Fix these promptly; the user shouldn't see them.
    } else if (response.status) {
      errMsg = `${response.status} - ${response.statusText}`;
    } else {
      errMsg = 'Server error';
    }
  }
}
